import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelRadio } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';
import {  getFechaProcesoPorModulo ,getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { connect } from 'react-redux';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { visualizarReporteEnPdf,generarReporteEnExcel} from '../../funciones_globales/interaccionApiReportes';
import { cargarPermisoBoton } from '../../funciones_globales/accionesPorUsuario';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';


const COD_BOTON_EXCEL = '090201';
class FormCartera02  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            cliente_sel: null,
            isVisibleBotonExcel:false,
            fechaDesde: null,
            fechaHasta: null,
        };

        this.imprimir = this.imprimir.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.imprimirExcel = this.imprimirExcel.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 2 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    componentDidMount(){
        
        let usuario = getItemDatosSesion('usuario');
        let fechaProceso = getFechaProcesoPorModulo('09');

        Promise.all([
            cargarPermisoBoton(COD_BOTON_EXCEL, usuario),
            this.props.generar_LogAuditoriaIngresoForm('0902')
        ])
        .then(([configBotonExcel ])=>{
            let isVisibleBotonExcel = false;

            if(configBotonExcel.display==='block'){
                isVisibleBotonExcel = true;
            }
            this.setState({              
                isVisibleBotonExcel
                ,fechaDesde: moment(fechaProceso, 'DD/MM/YYYY')
                ,fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
            });
        })
        .catch((error)=>{
            alert(error);
        }) 
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0902');
    }

    imprimir(){
        try{

            let urlReportWithParams=`&rpt=171`

            urlReportWithParams = urlReportWithParams +`&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`
            urlReportWithParams = urlReportWithParams +`&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`

            if(this.state.cliente_sel){
                urlReportWithParams+=`&param3=${this.state.cliente_sel.value}`;
            }

            visualizarReporteEnPdf(urlReportWithParams);
            
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }
    imprimirExcel(){
        try{
            let urlReportWithParams=`&rpt=133`;

            if(this.state.cliente_sel){
                urlReportWithParams+=`&param1=${this.state.cliente_sel.value}`;
            }

            generarReporteEnExcel(urlReportWithParams);
            
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
      }


    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('09');

        this.setState({cliente_sel: null
            ,fechaDesde: moment(fechaProceso, 'DD/MM/YYYY')
            ,fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
            
        })
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
                <HeaderForm>
                    <TituloForm>Cuentas por Cobrar: Evaluacion Cliente</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Fecha. Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Fecha. Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>
                        </ContainerCol>
                    </Row>

                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Cliente:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6'>
                            <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} func_onChange={(value)=>{if(Array.isArray(value)){value=null};this.setState({cliente_sel: value})}}/>
                        </ContainerCol>
                    </Row>  

                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimir}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir PDF</button>  
                                {this.state.isVisibleBotonExcel?
                                      <button type='button' className='btn btn-success btn-sm' onClick={this.imprimirExcel}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir EXCEL</button>  
                                      :
                                      null
                                }
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormCartera02);